import { render } from "./location.vue?vue&type=template&id=7492a146&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=7492a146&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7492a146"

export default script